'use strict';

var SubmitForAnalysisModalDirective = function SubmitForAnalysisModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/submit-for-analysis-modal.html'),
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
    }
  };
};
SubmitForAnalysisModalDirective.$inject = [];
module.exports = SubmitForAnalysisModalDirective;